<template>
  <div>
    <div class="">
      <a-button type="primary" icon="plus" @click="showAddTeam(0)">
        新增运动组
      </a-button>
    </div>

    <div class="mt10 mb10">
      <el-form :inline="true" :model="form" class="ant-advanced-search-form" size="small">
        <el-form-item label="组别名称">
          <el-input v-model="form.name" placeholder="请输入组别名称"></el-input>
        </el-form-item>
        <el-form-item label="所属运动队">
          <el-select v-model="form.teamId" placeholder="请选择所属运动队">
            <el-option
              :label="item.label"
              :value="item.value"
              :key="index"
              v-for="(item, index) in teams"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="状态">
          <el-select v-model="form.status" placeholder="请选择状态">
            <el-option label="全部" value=""></el-option>
            <el-option label="启用" :value="1"></el-option>
            <el-option label="禁用" :value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="添加时间">
          <el-date-picker
            v-model="form.addDate"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            :default-time="['00:00:00', '23:59:59']" 
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="btnOperation('search')" icon="el-icon-search">查询</el-button >
          <el-button type="" @click="btnOperation('reload')" icon="el-icon-refresh">重置</el-button>
        </el-form-item>
      </el-form>
    </div>

    <!-- 数据列表 -->
    <el-table element-loading-text="加载中" :data="dataSource">
      <el-table-column label="编号" align="center" type="index" width="50" />
      <el-table-column label="组别名称" align="center" prop="name" width="150" />
      <el-table-column label="所属运动队" align="center" prop="teamName" />
      <el-table-column label="运动员人数" align="center" prop="athletesNum" />
      <el-table-column label="管理员人数" align="center" prop="managerNum" />
      <el-table-column label="科研员人数" align="center" prop="researcherNum" />
      <el-table-column label="教练人数" align="center" prop="coachNum" />
      <el-table-column label="状态" align="center" prop="status">
        <template slot-scope="scope">
          <!-- <el-switch
            v-model="scope.row.status"
            :active-value="1"
            :inactive-value="2"
            @change="switchChange(scope.row)"
          ></el-switch> -->
          {{scope.row.status == 1 ? '启用' : '禁用'}}
        </template>
      </el-table-column>
      <el-table-column label="添加时间" align="center" prop="createTime" width="180">
        <template slot-scope="scope">
          {{ scope.row.createTime ? moment(scope.row.createTime).format("yyyy-MM-DD HH:mm:ss") : "" }}
        </template>
      </el-table-column>
      <el-table-column label="添加人" align="center" prop="createBy" />
      <el-table-column label="操作" align="center" fixed="right" width="240">
        <template slot-scope="scope">
          <el-button size="small" plain type="primary" @click="showAddTeam(1, scope.row)" >编辑</el-button >
          <el-button size="small" plain type="danger" @click="handleDel(scope.row)" >删除</el-button >
          <el-button size="small" plain type="primary" @click="toManManage(scope.row)" >成员管理</el-button >
        </template>
      </el-table-column>
    </el-table>
    <pagination :total="total" :page.sync="form.pageNum" :limit.sync="form.pageSize" @pagination="_getList" />

    <!-- 新建运动队 -->
    <el-dialog
      :title="addTitle"
      :visible.sync="addTeam"
      width="700px"
      append-to-body
    >
      <el-form
        ref="addTeam"
        :model="addTeamForm"
        :rules="rules"
        label-width="120px"
      >
        <el-form-item label="所属运动队:" prop="teamId">
          <el-select v-model="addTeamForm.teamId" placeholder="请选择所属运动队" clearable size="small" >
            <el-option v-for="(item, index) in teams" :key="index" :label="item.label" :value="item.value" />
          </el-select>
        </el-form-item>
        <el-form-item label="组别名称:" prop="name">
          <el-input
            clearable
            size="small"
            style="width: 400px"
            placeholder="请输入组别名称"
            v-model="addTeamForm.name"
          />
        </el-form-item>
        <el-form-item label="备注说明:" prop="remark">
          <el-input
            :rows="4"
            show-word-limit
            type="textarea"
            maxlength="100"
            placeholder="请输入备注说明"
            style="width: 400px"
            v-model="addTeamForm.remark"
          />
        </el-form-item>
        <el-form-item label="状态:" prop="status">
          <el-switch
            el-switch
            v-model="addTeamForm.status"
            :active-value="1"
            :inactive-value="2"
          ></el-switch>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancel">取 消</el-button>
        <el-button type="primary" @click="confirm">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import moment from "moment";
import * as API_Member from "@/api/train/member";

export default {
  props: {
    teamId: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      id: 0,
      teams: [], // 运动队
      addTitle: "新增运动组",
      form: {
        name: null,
        teamId: null,
        status: null,
        addDate: null,
        pageNum: 1,
        pageSize: 10,
      },
      addTeam: false,
      addTeamForm: {
        teamId: null,
        name: null,
        remark: null,
        status: 1,
      },
      rules: {
        teamId: [
          { required: true, message: "请选择所属运动队", trigger: "change" },
        ],
        name: [{ required: true, message: "请输入组别名称", trigger: "blur" }],
        // status: [{ required: true }],
      },
      dataSource: [],
      total: 0,
    };
  },
  watch: {
    teamId(newVal) {
      console.log('teamId');
      this.form.teamId = newVal;
      this._getList()
    }
  },
  methods: {
    moment,
    handleDel(e) {
      this.$confirm(`确定删除该数据吗？`, "提示", {
        cancelButtonText: "取消",
        confirmButtonText: "确定",
        type: "warning",
      })
        .then(() => {
          this._del(e);
        })
        .catch(() => {});
    },
    // 删除
    _del(record) {
      const params = {
        ids: [record.id],
      };
      API_Member.groupDel(params).then((res) => {
        console.log(res);
        if (res.code == 200) {
          this.$message.success("删除成功");
          this._getList();
        }
      });
    },
    // 切换开关
    switchChange(e) {
      const params = {
        id: e.id,
        status: e.status,
      };
      API_Member.groupSwitch(params).then((res) => {
        if (res.code == 200) {
          this.$message.success("状态修改成功");
          this._getList();
        }
      });
    },
    // 获取运动队下拉列表
    _getTeams() {
      API_Member.teamList().then((res) => {
        // console.log(res);
        if (res.code == 200) {
          this.teams = res.data.map((item) => {
            return {
              value: item.id,
              label: item.name,
              key: item.id,
            };
          });
          // console.log(this.teams);
        }
      });
    },
    cancel() {
      this.addTeamForm = { status: 1 };
      this.$refs.addTeam.resetFields();
      this.addTeam = false;
      // this.$refs.addTeam.clearValidate();
    },
    confirm() {
      this.$refs.addTeam
        .validate()
        .then((res) => {
          const url = this.id ? "groupEdit" : "groupAdd";
          let { id, teamId, name, remark, status } = this.addTeamForm;
          let params = {
            id,
            teamId,
            name,
            remark,
            status,
          };
          API_Member[url](params).then((res) => {
            console.log(res);
            if (res.code == 200) {
              this.$message.success("操作成功");
              this.cancel(); // 清空表单
              if (this.id) {
                this._getList();
              } else {
                this.reset();
              }
            }
          });
        })
        .catch(() => {});
    },
    _getList() {
      let params = {
        ...this.form,
        startTime: this.form.addDate && +this.form.addDate[0],
        endTime: this.form.addDate && +this.form.addDate[1],
      };
      console.log(params);
      API_Member.getGroupList(params).then((res) => {
        console.log(res);
        if (res.code == 200) {
          this.dataSource = res.data.list;
          this.total = res.data.total;
        }
      });
    },
    reset() {
      this.form = {
        name: null,
        teamId: null,
        status: null,
        addDate: null,
        pageNum: 1,
        pageSize: 10,
      };
      this._getList();
    },
    // 刷新列表
    reflash(flag) {
      const { name, status, addDate, teamId } = this.form;
      let params = {
        name,
        status,
        teamId,
        startTime: addDate && +addDate[0],
        endTime: addDate && +addDate[1],
        pageNum: this.pagination.current,
      };
      this.getList(params, flag);
    },
    //查询重置
    btnOperation(type) {
      switch (type) {
        case "search":
          this.form.pageNum = 1;
          this._getList();
          break;
        case "reload":
          this.reset();
          break;
      }
    },
    showAddTeam(type, row) {
      if (type == 0) {
        this.id = 0;
        this.addTitle = "新增运动组";
      } else {
        this.addTitle = "编辑运动组";
        this.id = row.id;
        this.addTeamForm = JSON.parse(JSON.stringify(row));
      }
      this.addTeam = true;
      console.log(this.teams);
    },
    toManManage(item) {
      this.$router.push({
        path: '/sportCenter/member',
        query: {
          groupId: item.id,
          teamId: item.teamId,
        },
      });
    }
  },
  mounted() {
    this.form.teamId = this.teamId
    this._getTeams();
    this._getList();
  }
};
</script>
<style lang="less">
@import "/src/styles/common/common.less";
</style>
<style lang="less" scoped></style>
